import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ImageDataLike } from 'gatsby-plugin-image';
import { ThemeColorsKeys } from '../../styles/tokens/colors';
import { getBackgroundColor } from '../../utils';
import { Button } from '../button';
import { Container } from '../container';
import { Spacer } from '../spacer';
import { Typography } from '../typography';
import { Image } from '../Image/Image';
import TickList from '../tickList/TickList';
import HtmlContent from '../htmlContent/HtmlContent';

// Interface

export interface FeatureHeroProps {
  image?: { image: { localFile: ImageDataLike } };
  subHeading?: string;
  heading: string;
  description?: string;
  buttonOne?: ButtonProps;
  backgroundColor?: ThemeColorsKeys;
  hasGradient?: boolean;
  tickListItems?: [];
}

export interface StyledFeatureHeroProps {
  hasImage?: boolean;
  backgroundColor?: string;
  hasGradient?: boolean;
}
export interface StyledBodyProps {
  hasImage?: boolean;
  backgroundColor?: string;
  hasGradient?: boolean;
}

export interface ButtonProps {
  url?: string;
  onClick?: any;
  label?: string;
  target?: string;
}

// Styles

const StyledFeatureHero = styled.div<StyledFeatureHeroProps>`
  ${({ theme: { colors } }) => css`
    position: relative;
    /* background-color: ${colors[backgroundColor]}; */

    background: rgb(209, 119, 38);
    background: linear-gradient(
      90deg,
      rgba(209, 119, 38, 1) 0%,
      rgba(255, 203, 5, 1) 22%,
      rgba(253, 195, 7, 1) 34%,
      rgba(209, 93, 38, 1) 100%
    );
  `};
`;

// const StyledImage = styled.div`
//   ${({ theme: { layers, media } }) => css`
//     .gatsby-image-wrapper {
//       height: 100%;
//       min-height: 250px;
//     }
//     @media (min-width: ${media.large}) {
//       z-index: ${layers.heroBackgroundImage};
//       object-fit: cover;
//     }
//   `};
// `;

const StyledBody = styled(Spacer)<StyledBodyProps>`
  ${({ theme: { space, media, layers, colors }, hasImage, hasGradient }) => css`
    ${getBackgroundColor('transparent')}
    padding: ${space.small};
    position: ${hasImage ? 'absolute' : 'relative'};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${layers.heroBody};
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 600px;
    margin: auto;

    ${hasGradient &&
    css`
      color: ${colors.neutralGrey};
      );
    `}

    @media (min-width: ${media.medium}) {
      padding: ${hasImage ? space.large : `${space.large} 0`};
    }
  `};
`;

const StyledButtons = styled.div`
  ${({ theme: { space, media, maxMedia } }) => css`
    margin-top: ${space.xxSmall};

    /* MAX WIDTH */
    @media (max-width: ${maxMedia.medium}) {
      > * {
        // Safari on < iOS 14.5
        @supports (-webkit-touch-callout: none) and (not (translate: none)) {
          &:not(:last-child) {
            margin-bottom: ${space.xSmall};
          }
        }
      }
    }

    @media (min-width: ${media.medium}) {
      margin-top: ${space.small};
    }
  `};
`;

// JSX

export const PromoBanner: FC<FeatureHeroProps> = ({
  heading,
  description,
  buttonOne,
  link,
}) => (
  <StyledFeatureHero>
    <Container>
      <StyledBody>
        <Spacer spacing="xSmall">
          {heading && <HtmlContent>{heading}</HtmlContent>}
          {description && (
            <Typography component="p" variant="bodyLarge">
              {description}
            </Typography>
          )}
        </Spacer>
        <StyledButtons>
          {buttonOne && <Button variant="primary" {...buttonOne} />}
          {link && <Button variant="primary" {...link} />}
        </StyledButtons>
      </StyledBody>
    </Container>
    {/* </StyledImage> */}
  </StyledFeatureHero>
);

export default PromoBanner;
